import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=259231cf&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259231cf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('259231cf')) {
      api.createRecord('259231cf', component.options)
    } else {
      api.reload('259231cf', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=259231cf&scoped=true&", function () {
      api.rerender('259231cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2KloDoSH3Xtbk/JS/comp/Accordion.vue"
export default component.exports